var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EA429C40-66AB-4772-B445-C4FD7B153228") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-2",
    transform: "translate(-130.000000, -1619.000000)",
    fill: "#7CBEEA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.250000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(106.750000, 1236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(13.000000, 270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bath",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2890625,2.5 C6.0234375,2.5 5,3.5234375 5,4.7890625 L5,20 L35,20 L37.5,20 L38.75,20 C39.4375,20 40,20.5625 40,21.25 C40,21.9375 39.4375,22.5 38.75,22.5 L37.5,22.5 L35,22.5 L5,22.5 L2.5,22.5 L1.25,22.5 C0.5625,22.5 0,21.9375 0,21.25 C0,20.5625 0.5625,20 1.25,20 L2.5,20 L2.5,4.7890625 C2.5,2.140625 4.640625,0 7.2890625,0 C8.5546875,0 9.7734375,0.5078125 10.671875,1.3984375 L12.6328125,3.359375 C13.5,2.8125 14.5234375,2.5 15.625,2.5 C17.203125,2.5 18.6328125,3.1484375 19.65625,4.203125 L19.7421875,4.1171875 C20.2265625,3.6328125 21.0234375,3.6328125 21.5078125,4.1171875 C21.9921875,4.6015625 21.9921875,5.3984375 21.5078125,5.8828125 L13.3828125,14.0078125 C12.8984375,14.4921875 12.1015625,14.4921875 11.6171875,14.0078125 C11.1328125,13.5234375 11.1328125,12.7265625 11.6171875,12.2421875 L11.703125,12.15625 C10.6484375,11.1328125 10,9.703125 10,8.125 C10,7.0234375 10.3125,6 10.859375,5.1328125 L8.8984375,3.171875 C8.4765625,2.7421875 7.890625,2.5 7.2890625,2.5 Z M2.5,25 L5,25 L5,28.75 C5,30.796875 5.984375,32.609375 7.5,33.75 C7.5,33.75 7.5,33.75 7.5,33.75 C7.5,33.75 7.5,33.75 7.5,33.75 C8.546875,34.53125 9.84375,35 11.25,35 L28.75,35 C30.15625,35 31.453125,34.53125 32.5,33.75 C32.5,33.75 32.5,33.75 32.5,33.75 C32.5,33.75 32.5,33.75 32.5,33.75 C34.015625,32.609375 35,30.796875 35,28.75 L35,25 L37.5,25 L37.5,28.75 C37.5,31.1328125 36.546875,33.296875 35,34.875 L35,38.75 C35,39.4375 34.4375,40 33.75,40 C33.0625,40 32.5,39.4375 32.5,38.75 L32.5,36.65625 C31.3671875,37.1953125 30.09375,37.5 28.75,37.5 L11.25,37.5 C9.90625,37.5 8.6328125,37.1953125 7.5,36.65625 L7.5,38.75 C7.5,39.4375 6.9375,40 6.25,40 C5.5625,40 5,39.4375 5,38.75 L5,34.875 C3.453125,33.296875 2.5,31.1328125 2.5,28.75 L2.5,25 Z M15.625,5 C13.8984375,5 12.5,6.3984375 12.5,8.125 C12.5,9.015625 12.875,9.8203125 13.46875,10.390625 L17.890625,5.96875 C17.3203125,5.375 16.515625,5 15.625,5 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/bath.e2d130107da967a6ea1920340c17be07.svg";
export { ForwardRef as ReactComponent };